module.exports = __webpack_public_path__ + "./fonts/Simple-Line-Iconsd41d.eot";